import { inject, Injectable } from '@angular/core';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkConnectionService {
  private connectionService = inject(ConnectionService);
  connectionState: ConnectionState;
  private networkChangeSubject = new Subject<ConnectionState>();
  networkChange$ = this.networkChangeSubject.asObservable();

  constructor() {
    this.connectionService
      .monitor()
      .pipe(takeUntilDestroyed())
      .subscribe(res => {
        if (
          this.connectionState?.hasNetworkConnection !== res.hasNetworkConnection ||
          this.connectionState?.hasInternetAccess !== res.hasInternetAccess
        ) {
          this.connectionState = { ...res };
          this.notifyNetworkChange();
        }
      });
  }

  notifyNetworkChange() {
    this.networkChangeSubject.next(this.connectionState);
  }
}
